import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const logOut = async () => {
  return await axiosInstance
    .post("user/logout")
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useLogOut = () => {
  return useMutation({
    mutationKey: ["user"],
    mutationFn: () => logOut(),
  });
};

export default useLogOut;
